import Router from 'next/router'
import {
  removeSessionCookies,
  cookieOpts,
  COOKIE_KEY,
  CSRF_COOKIE_KEY
} from './utils'
import config from 'config'
import { isRelativePath } from 'src/lib/util/url'
import { parse } from 'url'
import * as R from 'ramda'
import { stringifySetCookie } from 'cookie'

export function removeSession(res, redirectUrl) {
  if (res) {
    res.statusCode = 302

    res.setHeader('Set-Cookie', [
      stringifySetCookie({
        ...cookieOpts,
        name: COOKIE_KEY,
        value: '',
        expires: new Date(0)
      }),
      stringifySetCookie({
        ...cookieOpts,
        name: CSRF_COOKIE_KEY,
        value: '',
        expires: new Date(0)
      })
    ])

    res.setHeader('Location', redirectUrl)
    res.end()
  }

  if (!res) {
    removeSessionCookies()
    Router.push(redirectUrl)
  }
}

export function serveRedirect(res, fetchRes, path, options = {}) {
  const { statusCode = 302, replace = false } = options
  const parsedBase = parse(config.NEXT_PUBLIC_YD_URL)
  const isLocal =
    path && (isRelativePath(path) || R.includes(parsedBase.hostname, path))
  if (isLocal && res) {
    res.statusCode = statusCode
    res.setHeader('Location', path)

    // if the API is setting (or deleting) a cookie,
    // ensure next.js response forwards that info
    if (fetchRes && fetchRes.headers && fetchRes.headers['set-cookie']) {
      res.setHeader('Set-Cookie', fetchRes.headers['set-cookie'])
    }

    return res.end()
  }

  if (isLocal && !res) {
    // TODO
    // client side fetch page
    return replace ? Router.replace(path) : Router.push(path)
  }
}
